import React, { useState, useEffect } from "react";
import { Slider, Typography, Box } from "@mui/material";

type Props = {
  values: number[];
  label?: string;
  defaultValue?: number;
   value?: number; // ✅ actual voltage (11, 33...)
  onChange?: (value: number) => void;
};

const VoltageSliderMUI: React.FC<Props> = ({
  values,
  label,
  defaultValue = 0,
    value,
  onChange,
}) => {
 // const [valueIndex, setValueIndex] = useState<number>(defaultValue);
const valueIndex =
  values.findIndex((v) => v === value) !== -1
    ? values.findIndex((v) => v === value)
    : 0;


  const handleChange = (_: Event, newValue: number | number[]) => {
    const index = newValue as number;
    onChange?.(values[index]); // ✅ send actual value
  };
  // const handleChange = (_: Event, newValue: number | number[]) => {
  //   const index = newValue as number;
  //   setValueIndex(index);

  //   // 🔥 send actual value (not index)
  //   onChange?.(values[index]);
  // };

  // // if defaultValue changes from parent
  // useEffect(() => {
  //   setValueIndex(defaultValue);
  // }, [defaultValue]);

  return (
    <Box sx={{ width: "100%", color: "#fff",padding: "0px 10px" }}>
      {/* <Typography mb={2} fontWeight={600}>
        {label} ({values[valueIndex]} kV)
      </Typography> */}

      <Slider
        value={valueIndex}
        min={0}
        max={values.length - 1}
        step={1}
        // marks={values.map((val, index) => ({
        //   value: index,
        //   label: val,
        // }))}
           marks={values.map((val, index) => ({
          value: index,
          label: val,
        }))}
        onChange={handleChange}
        sx={{
          color: "#00cfff",
          "& .MuiSlider-markLabelActive": {
            color: "#00cfff",
            fontWeight: "bold",
          },
        }}
      />
    </Box>
  );
};

export default VoltageSliderMUI;